import { render } from "./ReviewSupplierInvoice.vue?vue&type=template&id=f117778c"
import script from "./ReviewSupplierInvoice.vue?vue&type=script&lang=js"
export * from "./ReviewSupplierInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__